import { primaryKey, headerCode, inputType, required, length, order, editable, Describer, GceEntity } from './gce-management';

/**
 * GceProfiliCompenso — lista statica dei profili compenso medici
 */
export class GceProfiliCompenso extends GceEntity {
    @primaryKey()
    @headerCode('GCE.GCEPROFILICOMPENSO.ID')
    @inputType('number')
    @editable(false)
    @order(1)
    id: number;

    @headerCode('GCE.GCEPROFILICOMPENSO.DESCRIZIONE')
    @inputType('text')
    @required()
    @editable(true)
    @length(255)
    @order(2)
    descrizione: string;

    constructor(id?: number, descrizione?: string) {
        super();
        this.id = id || 0;
        this.descrizione = descrizione || '';
    }

    static getAll(): GceProfiliCompenso[] {
        const data: [number, string][] = [
            [189, 'ADANTI IGIENISTA'],
            [78,  'ALLAMPRESE'],
            [77,  'Bacchetta'],
            [211, 'BESTE - FIORENZA'],
            [210, 'BESTE - PIACENZA'],
            [208, 'BESTE 30% - 30 €'],
            [240, 'CACOPARDI A.'],
            [73,  'CARROZZO'],
            [212, 'CARUSO SILVIA'],
            [246, 'CAVIGGIOLI - GRIVETTO'],
            [248, 'CAVIGGIOLI - IGIENISTA 30%'],
            [249, 'CAVIGGIOLI - IGIENISTA 35%'],
            [247, 'CAVIGGIOLI - VANZULLI'],
            [138, 'D. BARUCH'],
            [203, 'D.FABRIS CAROLINA'],
            [206, 'D.TILEVKSY'],
            [74,  'DOCTOR DENTIST'],
            [191, 'ESPOSITO CHIARA'],
            [308, 'ESTETICA BARUCH'],
            [274, 'ESTETICA MEDICALPRO'],
            [81,  'Fascia A'],
            [82,  'Fascia A+'],
            [80,  'Fascia B'],
            [177, 'FI POLLAIOLO 27%'],
            [176, 'FI POLLAIOLO 30%'],
            [180, 'FI POLLAIOLO IGIENISTA 25€'],
            [178, 'FI POLLAIOLO ORTO 35%'],
            [179, 'FI POLLAIOLO ORTO 40%'],
            [70,  'GALLERANO'],
            [68,  'GB IGIENISTA 10 80€'],
            [32,  'GB IGIENISTA 100€ FISSO 30%'],
            [60,  'GB IGIENISTA 2 100€ 20% 10%'],
            [61,  'GB IGIENISTA 3 100€'],
            [62,  'GB IGIENISTA 4 100€ + 10% 20%'],
            [63,  'GB IGIENISTA 5 80€'],
            [64,  'GB IGIENISTA 6 20€'],
            [65,  'GB IGIENISTA 7 80€'],
            [66,  'GB IGIENISTA 8 80€'],
            [67,  'GB IGIENISTA 9 80€ FISSO'],
            [86,  'GB IGIENISTA SOLO FISSO €300'],
            [118, 'GB JUNIOR ADVANCED €150 + 19%'],
            [58,  'GB JUNIOR ADVANCED 100€ + 10%'],
            [103, 'GB JUNIOR ADVANCED 125 + 15%'],
            [57,  'GB JUNIOR ADVANCED 125€ + 10%'],
            [53,  'GB JUNIOR ADVANCED 125€ + 12%'],
            [105, 'GB JUNIOR ADVANCED 125€ + 12% ELITE'],
            [104, 'GB JUNIOR ADVANCED 125€ + 12% ELITE PLUS'],
            [54,  'GB JUNIOR ADVANCED 125€ + 15%'],
            [55,  'GB JUNIOR ADVANCED 125€ + 17%'],
            [112, 'GB JUNIOR ADVANCED 125€ + 17% + 18€ abt'],
            [56,  'GB JUNIOR ADVANCED 125€ + 20%'],
            [109, 'GB JUNIOR ADVANCED 125€ + 22%'],
            [50,  'GB ORTODONTISTA 4'],
            [51,  'GB ORTODONTISTA 5'],
            [52,  'GB ORTODONTISTA 6'],
            [83,  'GB ORTODONTISTA FISSO €500'],
            [84,  'GB ORTODONTISTA FISSO €600'],
            [85,  'GB ORTODONTISTA FISSO €800'],
            [28,  'GB SENIOR'],
            [43,  'GB SENIOR 10'],
            [101, 'GB SENIOR 10 ELITE PLUS'],
            [44,  'GB SENIOR 11'],
            [96,  'GB SENIOR 11 ELITE PLUS'],
            [45,  'GB SENIOR 12'],
            [46,  'GB SENIOR 13'],
            [113, 'GB SENIOR 13 ELITE PLUS'],
            [47,  'GB SENIOR 14'],
            [48,  'GB SENIOR 15'],
            [49,  'GB SENIOR 16'],
            [59,  'GB SENIOR 17 100€ + 20% 30%'],
            [111, 'GB SENIOR 18'],
            [35,  'GB SENIOR 2'],
            [110, 'GB SENIOR 2 ELITE PLUS +17%'],
            [108, 'GB SENIOR 200 FISSO + 21%'],
            [36,  'GB SENIOR 3'],
            [102, 'GB SENIOR 3 ELITE PLUS'],
            [37,  'GB SENIOR 4'],
            [38,  'GB SENIOR 5'],
            [39,  'GB SENIOR 6'],
            [40,  'GB SENIOR 7'],
            [41,  'GB SENIOR 8'],
            [42,  'GB SENIOR 9'],
            [106, 'GB SENIOR ELITE PLUS 27%'],
            [207, 'I. LABARBERA'],
            [116, 'IDENTICOOP 28%'],
            [117, 'IDENTICOOP 35% IGIENISTA'],
            [115, 'IDENTICOOP NON SOCIO'],
            [114, 'IDENTICOOP SOCIO'],
            [75,  'IGI DRD'],
            [279, 'IGIENE WEISS'],
            [10,  'IGIENISTA 15€'],
            [11,  'IGIENISTA 18€'],
            [144, 'IGIENISTA 18€ - 25% - 7%'],
            [90,  'IGIENISTA 18€ CON LASER'],
            [188, 'IGIENISTA 20 € - 7% CON LASER'],
            [124, 'IGIENISTA 20 € (ex 18€) 7%'],
            [123, 'IGIENISTA 20€ (ex 15 €) 7%'],
            [141, 'IGIENISTA 20€ (ex 15 €) CON LASER - 7%'],
            [205, 'IGIENISTA 22 € - 7% - SPECIAL'],
            [254, 'IGIENISTA 22€ SPECIAL CON LASER'],
            [174, 'IGIENISTA 25 € - 7 % SPECIAL CON LASER'],
            [170, 'IGIENISTA 25 € - 7% - SPECIAL'],
            [253, 'IGIENISTA 25€ - 25%'],
            [251, 'IGIENISTA 25€ - 30,5 %'],
            [185, 'IGIENISTA 28 € - 20%'],
            [309, 'IGIENISTA 28 € - 28%'],
            [250, 'IGIENISTA 28 € - 28,5 %'],
            [277, 'IGIENISTA 28 € -20 % + LASER'],
            [172, 'IGIENISTA 28€ - 25%'],
            [252, 'IGIENISTA 28€ - 30%'],
            [225, 'IGIENISTA 30 €  - 20%'],
            [204, 'IGIENISTA 35 € -  20 %'],
            [148, 'IGIENISTA ELITE 22 €'],
            [150, 'IGIENISTA ELITE 22 € CON LASER'],
            [175, 'IGIENISTA ELITE PLUS + 25%'],
            [149, 'IGIENISTA ELITE PLUS 25 €'],
            [151, 'IGIENISTA ELITE PLUS 25 € CON LASER'],
            [136, 'IGIENISTA IDC €22 7%'],
            [3,   'JUNIOR'],
            [281, 'JUNIOR 10 % - ABT 28 €'],
            [119, 'JUNIOR 10%'],
            [276, 'JUNIOR 10% - ABT 22'],
            [306, 'JUNIOR 10% - SPECIAL 25% ABT 28€'],
            [168, 'JUNIOR 10% - SPECIAL abt 25€'],
            [156, 'JUNIOR 23% - 10%'],
            [165, 'JUNIOR 23% ELITE 10%'],
            [166, 'JUNIOR 23% ELITE PLUS 10%'],
            [30,  'JUNIOR BASIC'],
            [92,  'JUNIOR ELITE'],
            [133, 'JUNIOR ELITE 10%'],
            [97,  'JUNIOR ELITE PLUS'],
            [134, 'JUNIOR ELITE PLUS 10%'],
            [87,  'JUNIOR GB 2'],
            [228, 'JUNIOR SPECIAL 26%-27%'],
            [229, 'JUNIOR SPECIAL 27%-28%'],
            [193, 'LAIOLA ANNA'],
            [72,  'MACALUSO'],
            [200, 'MARTINI SARA IGIENISTA'],
            [285, 'MEDICALPRO - BOLDREGHINI'],
            [310, 'MEDICALPRO - CISERO'],
            [289, 'MEDICALPRO - CONTEGIACOMO'],
            [304, 'MEDICALPRO - CORGIAT'],
            [286, 'MEDICALPRO - DI CUIA'],
            [305, 'MEDICALPRO - GHAREHBAGHI'],
            [307, 'MEDICALPRO - GIORIO'],
            [293, 'MEDICALPRO - GUERCIO'],
            [303, 'MEDICALPRO - LALE LACROIX'],
            [288, 'MEDICALPRO - LAVAGNINO/ROTUNDO'],
            [290, 'MEDICALPRO - LOGOPEDISTA'],
            [284, 'MEDICALPRO - LOVATO'],
            [301, 'MEDICALPRO - MARCO'],
            [298, 'MEDICALPRO - MASERIN'],
            [294, 'MEDICALPRO - MAZZA'],
            [302, 'MEDICALPRO - MELLO TEGGIA'],
            [299, 'MEDICALPRO - MOTTOLA'],
            [297, 'MEDICALPRO - OTORINOLARINGOIATRIA'],
            [300, 'MEDICALPRO - PESOLA/PERRONE'],
            [292, 'MEDICALPRO - ROSSETTI'],
            [291, 'MEDICALPRO - VITTORIA'],
            [264, 'MERLINI - CARATZU'],
            [282, 'MERLINI - DONEDDU'],
            [2,   'MIDDLE'],
            [91,  'MIDDLE CON LASER'],
            [93,  'MIDDLE ELITE'],
            [98,  'MIDDLE ELITE PLUS'],
            [224, 'MIDDLE NEW 10 %  - ABT 28 €'],
            [121, 'MIDDLE NEW 10%'],
            [152, 'MIDDLE NEW ELITE 10%'],
            [139, 'MIDDLE NEW ELITE PLUS - 10%'],
            [196, 'MIDDLE NEW ELITE PLUS 10% - SPECIAL + LASER'],
            [140, 'MIDDLE NEW ELITE PLUS CON LASER - 10%'],
            [230, 'MIDDLE NEW SPECIAL 28%-29%'],
            [231, 'MIDDLE NEW SPECIAL 29%-30%'],
            [238, 'MIDDLE NEW SPECIAL ABT 25'],
            [120, 'MIDDLE OLD 10%'],
            [135, 'MIDDLE OLD ELITE 10%'],
            [132, 'MIDDLE OLD ELITE PLUS 10%'],
            [232, 'MIDDLE OLD SPECIAL 28%-31%'],
            [233, 'MIDDLE OLD SPECIAL 29%-32%'],
            [71,  'MOLA'],
            [137, 'ORTO 35% MIDDLE OLD ELITE - 10%'],
            [142, 'ORTO 35% SENIOR ELITE - 10%'],
            [161, 'ORTO JUNIOR 27% (25%)'],
            [160, 'ORTO MIDDLE 30% (27%)'],
            [159, 'ORTO MIDDLE ADV 32% (28,5%)'],
            [158, 'ORTO SENIOR 35% (30%)'],
            [186, 'ORTO SENIOR 37% (30%)'],
            [157, 'ORTO SENIOR ADV 40% (30%)'],
            [12,  'ORTODONTISTA JUNIOR 30%'],
            [9,   'ORTODONTISTA JUNIOR 35%'],
            [125, 'ORTODONTISTA JUNIOR 35% - 10%'],
            [6,   'ORTODONTISTA JUNIOR 40%'],
            [8,   'ORTODONTISTA MIDDLE 35%'],
            [4,   'ORTODONTISTA MIDDLE 40%'],
            [130, 'ORTODONTISTA MIDDLE NEW 35% - 10%'],
            [143, 'ORTODONTISTA MIDDLE NEW% 40% - 10%'],
            [126, 'ORTODONTISTA MIDDLE OLD 35% - 10%'],
            [162, 'ORTODONTISTA MIDDLE OLD 40 % - 10%'],
            [7,   'ORTODONTISTA SENIOR 35%'],
            [127, 'ORTODONTISTA SENIOR 35% - 10%'],
            [5,   'ORTODONTISTA SENIOR 40%'],
            [131, 'ORTODONTISTA SENIOR 40% - 10%'],
            [171, 'PRE - JUNIOR ADVANCED OLD - SPECIAL'],
            [146, 'PRE - JUNIOR ADVANCED OLD 20%'],
            [268, 'PRE - JUNIOR NEW SPECIAL 22€'],
            [257, 'PRE - JUNIOR NEW SPECIAL 22€ + LASER'],
            [242, 'PRE - JUNIOR NEW SPECIAL 25€'],
            [145, 'PRE - JUNIOR OLD 15%'],
            [153, 'PRE - JUNIOR OLD 15% - 20 €'],
            [267, 'PRE JUNIOR 10% - ABT 28€'],
            [266, 'PRE JUNIOR 20% - ABT 28€'],
            [256, 'PRE JUNIOR ADV 23% - ABT 28€'],
            [182, 'PRE-JUNIOR ADVANCED NEW 23%'],
            [181, 'PRE-JUNIOR NEW 20%'],
            [184, 'PRE-JUNIOR NEW 20% CON LASER'],
            [107, 'profilo nuovo'],
            [213, 'PROMEDICA - IGIENISTA'],
            [216, 'PROMEDICA 27'],
            [219, 'PROMEDICA 30'],
            [190, 'ROPA'],
            [183, 'SALVADORI'],
            [194, 'SCOGNAMIGLIO MARTINA'],
            [1,   'SENIOR'],
            [155, 'SENIOR 10%'],
            [169, 'SENIOR 10% - SPECIAL'],
            [173, 'SENIOR 32% - MOURAD'],
            [167, 'SENIOR ADV 10% - SPECIAL'],
            [271, 'SENIOR ADV 10% - SPECIAL € 25 + LASER'],
            [270, 'SENIOR ADV 30% - 31%'],
            [236, 'SENIOR ADV SPECIAL 31%'],
            [237, 'SENIOR ADV SPECIAL 32%'],
            [122, 'SENIOR ADV. 10%'],
            [128, 'SENIOR ADV. ELITE 10%'],
            [129, 'SENIOR ADV. ELITE PLUS 10%'],
            [147, 'SENIOR CON LASER'],
            [94,  'SENIOR ELITE'],
            [163, 'SENIOR ELITE 10%'],
            [100, 'SENIOR ELITE PLUS'],
            [164, 'SENIOR ELITE PLUS 10%'],
            [88,  'SENIOR GB 17'],
            [234, 'SENIOR SPECIAL 29,5%-30%'],
            [235, 'SENIOR SPECIAL 30,5%-31%'],
            [192, 'SORRENTINO ALESSIA'],
            [195, 'TOLARDO MARCO'],
            [243, 'VANZAGHI'],
            [154, 'VD - 25%'],
            [259, 'VENTURA - BELLA'],
            [262, 'VENTURA - GAVEGLIO'],
            [263, 'VENTURA - PULPITO'],
            [260, 'VENTURA - VINDIGNI'],
        ];
        return data.map(([id, descrizione]) => new GceProfiliCompenso(id, descrizione));
    }

    static getStructure(): Array<any> {
        return Describer.getStructure(new GceProfiliCompenso());
    }

    protected static getActions(): any[] { return []; }
}
